import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthenticatedLayout from '../../components/layout/AuthenticatedLayout';
import { CreatePostHeader } from './components/CreatePostHeader';
import { CreatePostUserInfo } from './components/CreatePostUserInfo';
import { CreatePostContent } from './components/CreatePostContent';
import { CreatePostMediaOptions } from './components/CreatePostMediaOptions';
import { CreatePostTypeSelector } from './components/CreatePostTypeSelector';
import { UploadMedia } from './components/UploadMedia';

type PostType = 'Chia sẻ' | 'Sự kiện' | 'Cảnh báo' | 'Cho' | 'Nhờ' | 'Cần';

interface PostData {
  id: string;
  content: string;
  media: string[];
  tag: PostType;
  createdAt: string;
}

const BottomSheet: React.FC<{
  onUpload: (files: File[]) => void;
  selectedTag: PostType | null;
  onSelectTag: (tag: PostType) => void;
}> = ({ onUpload, selectedTag, onSelectTag }) => (
  <div className="w-full max-w-md mx-auto px-0 pt-2 flex flex-col gap-3 z-10">
    <CreatePostMediaOptions onUpload={onUpload} />
    <CreatePostTypeSelector selectedTag={selectedTag} onSelectTag={onSelectTag} />
  </div>
);

const CreatePostPage: React.FC = () => {
  const navigate = useNavigate();
  const [media, setMedia] = useState<string[]>([]); // store image URLs
  const [selectedTag, setSelectedTag] = useState<PostType | null>(null);
  const [content, setContent] = useState('');

  const handleUpload = (files: File[]) => {
    Promise.all(files.map(file => {
      return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => resolve(e.target?.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    })).then(urls => setMedia(urls));
  };

  const handleSubmitPost = () => {
    if (!selectedTag || !content.trim()) return;
    const newPost: PostData = {
      id: Date.now().toString(),
      content,
      media,
      tag: selectedTag,
      createdAt: new Date().toISOString(),
    };
    const posts = JSON.parse(localStorage.getItem('locuno_posts') || '[]');
    posts.unshift(newPost);
    localStorage.setItem('locuno_posts', JSON.stringify(posts));
    navigate('/feed');
  };

  const isDisabled = !selectedTag || !content.trim();

  return (
    <AuthenticatedLayout showBottomNav={false} showNavbar={false} backgroundColor="#FBF6F1">
      <div className="min-h-screen flex flex-col max-w-md mx-auto justify-end">
        <div>
          <CreatePostHeader onSubmit={handleSubmitPost} disabled={isDisabled} />
          <CreatePostUserInfo />
          <CreatePostContent value={content} onChange={e => setContent(e.target.value)} />
        </div>
        <div className="flex flex-col w-full mt-auto">
          <UploadMedia media={media} />
          <div className="w-full flex flex-col items-end">
            <BottomSheet
              onUpload={handleUpload}
              selectedTag={selectedTag}
              onSelectTag={setSelectedTag}
            />
          </div>
        </div>
      </div>
    </AuthenticatedLayout>
  );
};

export default CreatePostPage; 